import { RoutalPalette, RoutalTooltip } from '@nx-smartmonkey/ui';

import Text from '../../../react-components/Text';

type PlanStatusBarComponentProps = {
  planId: string;
  pendingStops: number;
  incompleteStops: number;
  completedStops: number;
  canceledStops: number;
  width: string;
};

export const StatusBarComponent = ({
  planId,
  pendingStops,
  incompleteStops,
  completedStops,
  canceledStops,
  width,
}: PlanStatusBarComponentProps) => {
  const totalStops = pendingStops + completedStops + canceledStops;

  if (totalStops === 0) return null;

  const bullet = {
    borderRadius: `12px`,
    height: `10px`,
    width,
    display: `inline-flex`,
    backgroundColor: RoutalPalette.neutral05,
  };

  const statusList = [
    ...(completedStops > 0
      ? [
          {
            id: 1,
            width: `${(completedStops * 100) / totalStops}%`,
            tooltipId: `plans.plans_in_progress.completed_stops`,
            value: completedStops,
            backgroundColor: RoutalPalette.statusColors.completed,
          },
        ]
      : []),
    ...(incompleteStops > 0
      ? [
          {
            id: 1,
            width: `${(incompleteStops * 100) / totalStops}%`,
            tooltipId: `plans.plans_in_progress.incomplete_stops`,
            value: incompleteStops,
            backgroundColor: RoutalPalette.statusColors.incomplete,
          },
        ]
      : []),
    ...(canceledStops > 0
      ? [
          {
            id: 2,
            width: `${(canceledStops * 100) / totalStops}%`,
            tooltipId: `plans.plans_in_progress.canceled_stops`,
            value: canceledStops,
            backgroundColor: RoutalPalette.statusColors.canceled,
          },
        ]
      : []),
    ...(pendingStops > 0
      ? [
          {
            id: 3,
            width: `${(pendingStops * 100) / totalStops}%`,
            tooltipId: `plans.plans_in_progress.pending_stops`,
            value: pendingStops,
            backgroundColor: RoutalPalette.statusColors.pending,
          },
        ]
      : []),
  ];

  return (
    <div style={bullet}>
      {statusList.map((status, idx) => {
        return (
          <RoutalTooltip
            id={`bullet-${planId}-${status.id}`}
            title={
              <Text
                style={{ textAlign: `center`, color: RoutalPalette.neutral00, fontSize: `12px` }}
                intlId={status.tooltipId}
                intlValues={{ number: status.value }}
              />
            }
            backgroundColor={status.backgroundColor}
            contentStyles={{
              height: `100%`,
              display: `flex`,
              minWidth: `8px`,
              flexDirection: `column`,
              justifyContent: `center`,
              alignItems: `center`,
              width: status.width,
              backgroundColor: status.backgroundColor,
              borderTopLeftRadius: `${idx === 0 ? `12px` : `0px`}`,
              borderBottomLeftRadius: `${idx === 0 ? `12px` : `0px`}`,
              borderTopRightRadius: `${idx === statusList.length - 1 ? `12px` : `0px`}`,
              borderBottomRightRadius: `${idx === statusList.length - 1 ? `12px` : `0px`}`,
            }}
          />
        );
      })}
    </div>
  );
};
